import React from 'react';

import { USER_TYPE } from '../../constants';
import FiltersSelectContent from '../FiltersSelectContent';

interface FilterUserTypeProps {
  type?: string;
}

const FilterUserType: React.FC<FilterUserTypeProps> = ({ type = 'userType' }) => (
  <FiltersSelectContent type={type} items={USER_TYPE} />
);
export default FilterUserType;
